import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {tap} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {TimeAppSuppliesService} from './services/time-app-supplies.service';
import {DataService} from '../services/data.service';

@Component({
    selector: 'app-time-app-material',
    templateUrl: './time-app-work-supply-management.component.html',
    styleUrl: './time-app-work-supply-management.component.scss'
})
export class TimeAppWorkSupplyManagementComponent implements OnInit {
    protected supplies;
    protected chosenDate;
    private destroyRef = inject(DestroyRef);

    constructor(private route: ActivatedRoute, private supplyService: TimeAppSuppliesService, private dataService: DataService) {
        this.supplies = supplyService.getObjectSupplies$();
    }

    ngOnInit(): void {
        this.chosenDate = this.dataService.getChosenDateFormatted();
        this.route.params.pipe(
            takeUntilDestroyed(this.destroyRef),
            tap(params => {
                this.supplyService.setOrder(params.orderID, params.pseudoOrderName);
            })
        ).subscribe();
    }

}
